export default __webpack_public_path__ + "static/media/stripe_logo.svg.43fcec0f.png";